import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202604",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 73060,
  clicks: 1469,
  adsSpendDollars: 5981,
  budgetDollars: 6000,
  salesDollars: 16127,
  bestEstimateRoas: 2.7,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 25,
  reorderConversions: 17,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
